import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActionItemModel } from '../action-button/action-button.component';
import { UniperAuthService } from '../../services/uniperAuth.service';

@Component({
  selector: 'app-ppa-inventory-header',
  templateUrl: './ppa-inventory-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPAInventoryHeaderComponent {
  addItems: ActionItemModel[] = [
    {
      Heading: 'Asset',
      Description: 'Manage Asset',
      Route: '/addppaobject/asset',
    },
    {
      Heading: 'MaLo',
      Description: 'Manage MaLo',
      Route: '/addppaobject/maLo',
    },
    {
      Heading: 'Transaction',
      Description: 'Manage Transaction',
      Route: '/addppaobject/transaction',
    },
    {
      Heading: 'Business Partner',
      Description: 'Manage Business Partner',
      Route: '/addppaobject/business-partner',
    },
    // {
    //   Heading: 'Market Participant',
    //   Description: 'Manage Market Participant',
    //   Route: '/addppaobject/market-participant',
    // },
    {
      Heading: 'Deal Group',
      Description: 'Manage Deal Group',
      Route: '/addppaobject/deal-group',
    }
  ];

  constructor(private authService: UniperAuthService){

  }

  hasInventoryAccess(){
    return this.authService.hasInventoryAccess;
  }
}
